const emitir_ficha_individual_por_aluno = [
  {
    path: "/emitir-ficha-individual-por-aluno",
    name: "emitir_ficha_individual_por_aluno",
    meta: {
      allowedPermissions: ["atasfinais_ficha_individual_turma_pdf"],
      breadCrumb: "Processo de Resultado Final - Encerramento do Ano Letivo",
    },
    component: () =>
      import(
        "@/views/EmitirFichaIndividualPorAluno/EmitirFichaIndividualPorAluno.vue"
      ),
  },
];

export { emitir_ficha_individual_por_aluno };
